import React from 'react';
// material ui
import AppBar from '@mui/material/AppBar';
import withStyles from '@mui/styles/withStyles';
import withRouter from 'src/config/withRouter';


const ColorAppBar = withStyles({
    root: {
        backgroundImage: 'linear-gradient(to right, #49ceff , #00185a)'
    },
  })(AppBar);




class Bar extends React.Component{
    constructor() {
        super();
        this.state = {
        }
    }

    render() {
    return(
        <div>
            <ColorAppBar position={this.props.position ? this.props.position : 'static'} style={{ backgroundImage: "linear-gradient(to right, #49ceff, #00185a)" }}>
                {this.props.children}
            </ColorAppBar>
        </div>
    )
    }
}


export default withRouter(Bar);